import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { GenWeekRow, GenWeekDay } from 'app/shared/week-row';
import { GenService } from 'app/shared/gen-ser.service';
import { DailyToken, DailyTokenItem } from 'app/shared/misc-classes';

@Component({
  selector: 'gen-calendar',
  templateUrl: './gen-calendar.component.html',
  styleUrls: ['./gen-calendar.component.css']
})
export class GenCalendarComponent implements OnChanges {

  @Input() year:number;
  @Input() month:number;
  @Input() items:Array<DailyToken>;
  @Input() showDatesOutside:boolean = false;
  @Output() itemSelected:EventEmitter<any> = new EventEmitter();

  today:Date = new Date();

  isLoaded:boolean = false;
  private prevLoadedYear:number;
  private prevLoadedMonth:number;


  weeks:Array<GenWeekRow> = []

  constructor(private genSer:GenService) {
   }

  ngOnChanges() {
    if(this.isLoaded == false || this.year != this.prevLoadedYear || this.month != this.prevLoadedMonth){
      this.prepareCalendarData();
    }

    if(this.items){

    }
  }

  getDateItems(_selDate:Date):Array<DailyTokenItem>{
   // console.log(this.items)
    if(this.items){
      let _currTokenObj:DailyToken = this.items.find((_tmpDailyToken:DailyToken) => {
        return _tmpDailyToken.selDate.getDate() == _selDate.getDate() && 
              _tmpDailyToken.selDate.getMonth() == _selDate.getMonth() &&         
              _tmpDailyToken.selDate.getFullYear() == _selDate.getFullYear();
      });
      if(_currTokenObj)
        return _currTokenObj.items;
    }
    return [];
  }

  ItemClicked(_refObj){
    if(_refObj && this.itemSelected){
      this.itemSelected.emit(_refObj);
    }
  }
  dateClicked(_refDate:Date){
    if(_refDate && this.itemSelected){
      this.itemSelected.emit({"selDate":_refDate});
    }
  }

  showThisDate(_currDate:Date){
    if(this.showDatesOutside == true) return true;
    else{
      return ((_currDate.getFullYear() == this.year) && (_currDate.getMonth() == (this.month - 1)));
    }
  }

  private prepareCalendarData(){
    this.isLoaded = false;
    let _weeks:Array<GenWeekRow> = []
    
    let _weekNums:Array<number> = GenService.getWeekNumbersForMonth(this.year,this.month);
    let _startDate:Date = null;
    let _endDate:Date = null;

     for(var i=0;i<_weekNums.length;i++){
          let wRow:GenWeekRow = new GenWeekRow(_weekNums[i]);
          let _dates:Array<Date> = GenService.getDatesForWeek(_weekNums[i],this.year);
          _dates.forEach((_dt:Date) => {
              wRow.addDay(_dt);
              if(_startDate == null) _startDate = _dt;
              if(_endDate == null || _endDate < _dt) _endDate = _dt;
          });
          _weeks.push(wRow);  
     }
    this.weeks = _weeks;
    this.prevLoadedYear = this.year;
    this.prevLoadedMonth = this.month;
    this.isLoaded = true;
  }



}
